const templateTrainingOptions = players => players.map((option, index) => `
  <div class="radio-option d-flex align-items-center">
    <input required class="radio-option__input" ${index === 0 ? 'checked' : ''} name="trainingOptionId" type="radio" value="${option.id}" id="player-${option.id}" />
    <label class="radio-option__label d-flex align-items-center" for="player-${option.id}">
      <div class="">
        ${option.process_time} Days
      </div>
      <div class="ml-auto">
        ${option.price > 0 ? `${option.price} ${option.wallet_type === 'NFSG' ? 'NFSG' : 'NFSGX'}` : option.use_card ? 'SPEED-UP CARD' : option.price}
      </div>
    </label>
  </div>
`).join(``);

export default templateTrainingOptions;
